import Vue from 'vue'
import Router from 'vue-router'
import { routers } from './router';


Vue.use(Router)

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

// 路由配置
const RouterConfig = {
    // mode: 'history',
    base: process.env.BASE_URL,
    routes: routers
};

export default new Router(RouterConfig);